import "./App.css";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
import { Layout } from "./components/Layout";
import Home from "./pages/HomePage";
import ToolPage from "./pages/ToolPage";
import CategoryPage from "./pages/CategoryPage";
import PresentFinder from "./pages/PresentFinder";
import GroupCreate from "./pages/GroupCreate";
import GroupRoom from "./pages/GroupRoom";
import HistoryPage from "./pages/HistoryPage";
import FavouritesPage from "./pages/FavouritesPage";
import AccountPage from "./pages/AccountPage";
import AuthPage from "./pages/AuthPage";
import NotFound from "./pages/NotFound";
import WheelsPage from "./pages/WheelsPage";
import GiftsPage from "./pages/GiftsPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import LandingPage from "./pages/LandingPage";
import LmsHome from "./pages/LmsHome";
import LmsCompetition, { LmsAdminLink } from "./pages/LmsCompetition";
import { LANDING_PAGES } from "./data/landingPages";
import { AboutPage, ContactPage, PrivacyPage } from "./pages/InfoPages";
import MessagesPage from "./pages/MessagesPage";
import AdminGiftsPage from "./pages/AdminGiftsPage";
import MeetPaulPage from "./pages/MeetPaulPage";

function KeyedCategory() {
  const { categoryId } = useParams();
  return <CategoryPage key={categoryId} />;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <DataProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/stuck" element={<Home autoStuck />} />
                <Route path="/tools/pick-a-number" element={<Navigate to="/tools/raffle-draw" replace />} />
                <Route path="/tools/:toolId" element={<ToolPage />} />
                <Route path="/category/presents" element={<Navigate to="/presents" replace />} />
                <Route path="/category/:categoryId" element={<KeyedCategory />} />
                <Route path="/presents" element={<PresentFinder />} />
                <Route path="/group/new" element={<GroupCreate />} />
                <Route path="/g/:groupId" element={<GroupRoom />} />
                <Route path="/gifts" element={<GiftsPage />} />
                <Route path="/gifts/:slug" element={<GiftsPage />} />
                <Route path="/admin/analytics" element={<AnalyticsPage />} />
                <Route path="/wheels" element={<WheelsPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/favourites" element={<FavouritesPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/about/paul" element={<MeetPaulPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/admin/messages" element={<MessagesPage />} />
                <Route path="/admin/gifts" element={<AdminGiftsPage />} />
                <Route path="/lms" element={<LmsHome />} />
                <Route path="/lms/:compId" element={<LmsCompetition />} />
                <Route path="/lms/:compId/admin/:token" element={<LmsAdminLink />} />
                {LANDING_PAGES.map((p) => <Route key={p.slug} path={`/${p.slug}`} element={<LandingPage key={p.slug} slug={p.slug} />} />)}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
            <Toaster position="top-center" toastOptions={{ className: "font-body font-semibold border-2 border-ink rounded-2xl" }} />
          </DataProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
